define([
  "marionette",
  "jquery",
  "messaging/messenger",
  "moment",
  "./taskWizardStepsPageView",
  "modules/tasks/taskWizardModal/taskSteps/taskStepsModule",
  "modules/tasks/taskWizardModal/taskLocales/taskLocalesModule",
], function (
  Marionnete,
  $,
  Messenger,
  moment,
  TaskWizardStepsPageView,
  TaskStepsModule,
  TaskLocalesModule,
) {
  "use strict";

  var TaskWizardStepsPageController = Marionnete.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "taskWizardStepsPage";
    },
    show: function (task) {
      this.task = task;
      this.view = new TaskWizardStepsPageView.stepsPageView({ model: this.task });
      // module for parent (non-locale specific) task steps. Default language Id for parent is 0
      this.taskSteps = this.addSubModule(
        new TaskStepsModule({
          languageId: 0,
          region: this.view.taskSteps,
          stepsRequired: false,
        }),
      );
      this.localeSteps = this.addSubModule(
        new TaskLocalesModule({
          region: this.view.localeSteps,
        }),
      );
      this.view.on("show", this._onShow, this);
      this.showRegion(this.view);
    },
    commitData: function () {
      this.view.clearErrors();
      this.task.set({
        description: this.view.getTaskDescription(),
        name: this.view.getTaskName(),
      });
      var valid = true;
      if (!this.taskSteps.commitData()) {
        valid = false;
      }
      if (!this.localeSteps.commitData()) {
        valid = false;
      }
      if (!this.task.get("name")) {
        this.view.nameError($.t("commonMessages.emptyMessage"));
        valid = false;
      }
      if (!this.task.get("description")) {
        this.view.descriptionError($.t("commonMessages.emptyMessage"));
        valid = false;
      }
      if (this.taskSteps.isEmpty() && this.localeSteps.isEmpty()) {
        this.view.taskStepsError($.t("task.wizard.emptyStepsAndLocales"));
        valid = false;
      }
      return valid;
    },
    _onShow: function () {
      this.taskSteps.show(this.task);
      this.localeSteps.show(this.task);
    },
  });

  return TaskWizardStepsPageController;
});
